import { createFileRoute } from '@tanstack/react-router';

import { PremiumLinksProvider } from '@features/landing/shared/providers/PremiumLinksProvider';
import { SummerLandingPage } from '@features/landing/summer/pages/SummerLandingPage';

export const Route = createFileRoute('/summer/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PremiumLinksProvider>
      <SummerLandingPage />
    </PremiumLinksProvider>
  );
}
